import ReactDOM from 'react-dom';
import { App } from './App';
import './index.scss';
import './fonts/Latinotype - Branding-Medium.otf';

ReactDOM.render(<App />, document.getElementById('root'));
